import {deleteTaskListUnit as deleteTaskListUnitGQL} from "../gql/mutations";

import {TaskListUnit} from "../gql/serverTypes";
import {queryGqlApi} from "../../../graphql/queryGqlApi";
import {IDataClientService} from "../../../platform/services/data/DataClientService";
import {IAuthService} from "../../../platform/services/auth/AuthService";


export const deleteTaskListUnit = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    taskListUnit: TaskListUnit
) => {
    let deletedValue = await queryGqlApi(
        deleteTaskListUnitGQL,
        {
            input: {
                id: taskListUnit.id,
            }
        },
        dataClientService,
        authService,
        'pgServer'
    );

    return deletedValue as unknown as TaskListUnit;
}
